import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { MODULE_NOTIFICATIONS } from '@core/constants/session.const';
import { IModuleNotificationModel } from '@models/notification/notification.model';
import { NotificationService } from '@services/notification/notification.service';
import { CurrentUserService } from '@services/common/currentuser.service';
import { ICurrentUserModel } from '@models/auth/auth.model';
import { convertKeysToLowerCase } from '@core/helpers/data.helper';

@Injectable({
  providedIn: 'root',
})
export class ModuleNotificationService {
  private cachedNotifications: IModuleNotificationModel[] = [];

  constructor(
    private storageService: StorageService,
    private notificationService: NotificationService,
    private currentUserService: CurrentUserService
  ) {
    this.loadInitialNotifications();
  }

  private async loadInitialNotifications() {
    try {
      const raw = await this.storageService.get(MODULE_NOTIFICATIONS);
      this.cachedNotifications = raw ? JSON.parse(raw) : [];
    } catch {
      this.cachedNotifications = [];
    }
  }

  get = async (moduleName = '') => {
    const currentUser: ICurrentUserModel = this.currentUserService.get();
    if (!currentUser?.userTypeId || !currentUser?.refId) {
      return;
    }
    this.notificationService
      .getModuleNotificationCount(
        currentUser.userTypeId,
        currentUser.refId,
        moduleName
      )
      .subscribe({
        next: async (response) => {
        let notifications = response?.data;
        if (moduleName) {
          const raw = await this.storageService.get(MODULE_NOTIFICATIONS);
          const moduleNotifications: IModuleNotificationModel[] = raw ? JSON.parse(raw) : [];
          notifications = moduleNotifications?.map((module) => {
            const moduleNotification = response?.data?.find(
              (notificationModule) =>
                notificationModule?.moduleName === module?.moduleName
            );
            return {
              ...module,
              notificationCount: moduleNotification
                ? moduleNotification?.notificationCount
                : module?.notificationCount,
            };
          });
        }

          await this.set(JSON.stringify(notifications));
        },
        error: () => {}
      });
  };

  private set = async (moduleNotifications: string) => {
    try {
      this.cachedNotifications = JSON.parse(moduleNotifications);
    } catch {
      // fallback
    }
    await this.storageService.set(MODULE_NOTIFICATIONS, moduleNotifications);
  };

  setModuleNotifications = async (moduleNotifications: string) => {
    const notifications = JSON.stringify(
      convertKeysToLowerCase(JSON.parse(moduleNotifications))
    );
    await this.set(notifications);
  };

  getCount = (moduleName: string) => {
    const module = this.cachedNotifications?.find(
      (moduleItem) =>
        moduleItem?.moduleName?.toLowerCase() === moduleName?.toLowerCase()
    );
    return module ? module?.notificationCount : 0;
  };
}
